/**
 * The Hive Guys - Modern Navigation Logic
 * Desktop Shop All hover-intent & click toggle + Mobile Drawer & Accordions
 */

(function () {
  'use strict';

  function initNav() {
    /* ------------------------------------------------------------------------
       Desktop Shop All Panel
       ------------------------------------------------------------------------ */
    const shopAllBtn = document.getElementById('NavShopAllBtn');
    const shopPanel = document.getElementById('NavShopPanel');

    if (shopAllBtn && shopPanel) {
      let openTimeout = null;
      let closeTimeout = null;

      const isPointerDevice = () => window.matchMedia('(hover: hover)').matches;

      function openShopPanel() {
        clearTimeout(closeTimeout);
        shopAllBtn.setAttribute('aria-expanded', 'true');
        shopAllBtn.classList.add('is-open');
        shopPanel.classList.add('is-open');
        shopPanel.setAttribute('data-open', 'true');
        const headerBottom = shopPanel.closest('.header__bottom');
        if (headerBottom) headerBottom.classList.add('is-panel-open');
      }

      function closeShopPanel(returnFocus = false) {
        clearTimeout(openTimeout);
        clearTimeout(closeTimeout);
        shopAllBtn.setAttribute('aria-expanded', 'false');
        shopAllBtn.classList.remove('is-open');
        shopPanel.classList.remove('is-open');
        shopPanel.setAttribute('data-open', 'false');
        const headerBottom = shopPanel.closest('.header__bottom');
        if (headerBottom) headerBottom.classList.remove('is-panel-open');
        if (returnFocus) {
          shopAllBtn.focus();
        }
      }

      function toggleShopPanel() {
        const isOpen = shopAllBtn.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          closeShopPanel();
        } else {
          openShopPanel();
        }
      }

      shopAllBtn.addEventListener('click', function (e) {
        e.preventDefault();
        toggleShopPanel();
      });

      // Hover-intent for pointer devices
      function onMouseEnter() {
        if (!isPointerDevice()) return;
        clearTimeout(closeTimeout);
        openTimeout = setTimeout(openShopPanel, 150);
      }

      function onMouseLeave() {
        if (!isPointerDevice()) return;
        clearTimeout(openTimeout);
        closeTimeout = setTimeout(function () {
          closeShopPanel();
        }, 250);
      }

      shopAllBtn.addEventListener('mouseenter', onMouseEnter);
      shopAllBtn.addEventListener('mouseleave', onMouseLeave);
      shopPanel.addEventListener('mouseenter', onMouseEnter);
      shopPanel.addEventListener('mouseleave', onMouseLeave);

      // Outside click to close
      document.addEventListener('click', function (e) {
        if (!shopPanel.classList.contains('is-open')) return;
        if (!shopPanel.contains(e.target) && !shopAllBtn.contains(e.target)) {
          closeShopPanel();
        }
      });

      // Escape key to close
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && shopPanel.classList.contains('is-open')) {
          closeShopPanel(true);
        }
      });
    }

    /* ------------------------------------------------------------------------
       Mobile Navigation Drawer
       ------------------------------------------------------------------------ */
    const drawerOpenBtn = document.getElementById('NavDrawerOpenBtn');
    const drawerCloseBtn = document.getElementById('NavDrawerCloseBtn');
    const drawerBackdrop = document.getElementById('NavDrawerBackdrop');
    const drawerDialog = document.getElementById('NavDrawerDialog');

    if (drawerOpenBtn && drawerDialog) {
      // Teleport backdrop and dialog to <body> to guarantee true viewport fixed positioning
      if (drawerBackdrop && drawerBackdrop.parentElement !== document.body) {
        document.body.appendChild(drawerBackdrop);
      }
      if (drawerDialog && drawerDialog.parentElement !== document.body) {
        document.body.appendChild(drawerDialog);
      }

      let lastFocusedElement = null;

      function openDrawer() {
        lastFocusedElement = document.activeElement;
        drawerDialog.classList.add('is-open');
        if (drawerBackdrop) drawerBackdrop.classList.add('is-active');
        drawerDialog.setAttribute('aria-hidden', 'false');
        drawerOpenBtn.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';

        // Focus close button or dialog
        setTimeout(() => {
          if (drawerCloseBtn) {
            drawerCloseBtn.focus();
          } else {
            drawerDialog.focus();
          }
        }, 50);
      }

      function closeDrawer() {
        drawerDialog.classList.remove('is-open');
        if (drawerBackdrop) drawerBackdrop.classList.remove('is-active');
        drawerDialog.setAttribute('aria-hidden', 'true');
        drawerOpenBtn.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';

        if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
          lastFocusedElement.focus();
        }
      }

      drawerOpenBtn.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer();
      });

      if (drawerCloseBtn) {
        drawerCloseBtn.addEventListener('click', function (e) {
          e.preventDefault();
          closeDrawer();
        });
      }

      if (drawerBackdrop) {
        drawerBackdrop.addEventListener('click', function (e) {
          e.preventDefault();
          closeDrawer();
        });
      }

      // Escape key to close drawer
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawerDialog.classList.contains('is-open')) {
          closeDrawer();
        }
      });

      // Focus trapping inside drawer
      drawerDialog.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;

        const focusables = drawerDialog.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
        );
        const visibleFocusables = Array.from(focusables).filter(
          (el) => el.offsetParent !== null
        );

        if (visibleFocusables.length === 0) return;

        const firstElement = visibleFocusables[0];
        const lastElement = visibleFocusables[visibleFocusables.length - 1];

        if (e.shiftKey) {
          if (document.activeElement === firstElement) {
            e.preventDefault();
            lastElement.focus();
          }
        } else {
          if (document.activeElement === lastElement) {
            e.preventDefault();
            firstElement.focus();
          }
        }
      });

      // Cart drawer integration on mobile
      const mainCartTrigger = document.querySelector('#cart-icon-bubble');
      const drawerCartTriggers = drawerDialog.querySelectorAll('.nav-trigger-cart');
      drawerCartTriggers.forEach((trigger) => {
        trigger.addEventListener('click', function (e) {
          if (mainCartTrigger && document.querySelector('cart-drawer')) {
            e.preventDefault();
            closeDrawer();
            mainCartTrigger.click();
          }
        });
      });
    }

    /* ------------------------------------------------------------------------
       Mobile Accordions (Single-open mode)
       ------------------------------------------------------------------------ */
    const accordionToggles = document.querySelectorAll('.nav-drawer__accordion-toggle');

    accordionToggles.forEach((toggle) => {
      toggle.addEventListener('click', function () {
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';
        const contentId = toggle.getAttribute('aria-controls');
        const content = document.getElementById(contentId);
        const icon = toggle.querySelector('.nav-drawer__accordion-icon');

        // Close all accordions first (single-open mode)
        accordionToggles.forEach((otherToggle) => {
          if (otherToggle !== toggle) {
            otherToggle.setAttribute('aria-expanded', 'false');
            const otherContentId = otherToggle.getAttribute('aria-controls');
            const otherContent = document.getElementById(otherContentId);
            if (otherContent) otherContent.hidden = true;
            const otherIcon = otherToggle.querySelector('.nav-drawer__accordion-icon');
            if (otherIcon) otherIcon.textContent = '+';
          }
        });

        // Toggle clicked accordion
        if (isOpen) {
          toggle.setAttribute('aria-expanded', 'false');
          if (content) content.hidden = true;
          if (icon) icon.textContent = '+';
        } else {
          toggle.setAttribute('aria-expanded', 'true');
          if (content) content.hidden = false;
          if (icon) icon.textContent = '–';
        }
      });
    });

    /* ------------------------------------------------------------------------
       Desktop Account Dropdown State (prevent clashing with The Hive Guide™)
       ------------------------------------------------------------------------ */
    const accountDetails = document.querySelector('.header__account details');
    if (accountDetails) {
      accountDetails.addEventListener('toggle', function () {
        const header = document.querySelector('.header');
        if (header) {
          if (accountDetails.open) {
            header.classList.add('is-account-open');
          } else {
            header.classList.remove('is-account-open');
          }
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNav);
  } else {
    initNav();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.classList.contains('shopify-section-header')) {
      initNav();
    }
  });
})();
